export default "__VITE_ASSET__RbGfU2Yl__"